import { FC } from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/material';

interface ProfileTypes {
    user: any;
    my?: number;
    width?: number | string;
    email?: string;
    showIcon?: string;
}

const Profile: FC<ProfileTypes> = ({ showIcon, user, my, width = 370 }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'row',
            backgroundColor: '#F9FAFB',
            width: width,
            justifyContent: 'flex-start',
            alignItems: 'center',
            p: 4,
            my: my,
            borderRadius: 2,
        }}
    >
        <div>
            <Avatar src={user?.logoUrl} sx={{ width: 74, height: 74 }} />
        </div>
        <Stack ml={5} spacing={2} direction={'row'} alignItems={'center'}>
            <div>
                <Typography sx={{ fontSize: 16, color: '#1F2937', fontWeight: 700 }} variant="h2">
                    {user?.name}
                </Typography>
                <Typography sx={{ fontSize: 14, color: '#6B7280', my: 0.2 }} variant="body2">
                    {user?.email || user?.username || ''}
                </Typography>
            </div>
            {/* {showIcon ?  <ArrowForwardIosIcon sx={{ }}/> :null} */}
        </Stack>
    </Box>
);

export default Profile;
